module.exports = __webpack_public_path__ + "images/logo/logo_blue.png";